import { SVGProps } from 'react';

export default function ChevronIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path d="M17.3002 9.32497C17.4835 9.50831 17.5752 9.74164 17.5752 10.025C17.5752 10.3083 17.4835 10.5416 17.3002 10.725L12.7002 15.325C12.6002 15.425 12.4919 15.496 12.3752 15.538C12.2585 15.5793 12.1335 15.6 12.0002 15.6C11.8669 15.6 11.7419 15.5793 11.6252 15.538C11.5085 15.496 11.4002 15.425 11.3002 15.325L6.6752 10.7C6.49186 10.5166 6.4002 10.2916 6.4002 10.025C6.4002 9.75831 6.5002 9.52497 6.7002 9.32497C6.88353 9.14164 7.11686 9.04997 7.4002 9.04997C7.68353 9.04997 7.91686 9.14164 8.1002 9.32497L12.0002 13.225L15.9252 9.29998C16.1085 9.11664 16.3335 9.02497 16.6002 9.02497C16.8669 9.02497 17.1002 9.12498 17.3002 9.32497Z" />
    </svg>
  );
}
